import '../styles/SignUpIdentityContext.css';
import React from 'react';
import { useProjectCollection } from '../lib/projectData';

const CAPABILITIES = [
  {
    label: 'Identity',
    value: 'Client identity bound to the account',
    credit: false,
  },
  {
    label: 'Account record',
    value: 'Created on submission',
    credit: false,
  },
  {
    label: 'Balance',
    value: 'Check account balance',
    credit: true,
  },
  {
    label: 'Transfers',
    value: 'Transfer funds',
    credit: true,
  },
  {
    label: 'History',
    value: 'View transfer history',
    credit: true,
  },
];

function formatAccountState(status, id) {
  const label =
    typeof status === 'string' && status.trim()
      ? status.trim().toUpperCase()
      : 'STATUS UNAVAILABLE';
  const ref = typeof id === 'string' && id.trim() ? id.trim() : '—';
  return `${label} · ${ref}`;
}

function SignUpIdentityContext() {
  const { data, loading, error } = useProjectCollection('client_accounts');
  const accounts = Array.isArray(data) ? data : [];
  const accountCount = accounts.length;

  return (
    <section className="sic-root" aria-labelledby="sic-heading">
      <div className="sic-inner">
        <div className="sic-rail">
          <p className="sic-micro">What this establishes</p>
          <h2 className="sic-heading" id="sic-heading">
            Your account, instrumented
          </h2>
          <p className="sic-intro">
            Enrolling establishes a client identity and creates the account record bound to
            it. Everything measured from there — balance, transfers, history — reads from that
            single record.
          </p>

          <div className="sic-rule" aria-hidden="true" />

          <div className="sic-ledger">
            <p className="sic-set-micro">Unlocked on enrollment</p>
            <ul className="sic-readouts">
              {CAPABILITIES.map((item) => (
                <li className="sic-row" key={item.label}>
                  <span className="sic-row-label">{item.label}</span>
                  <span
                    className={
                      item.credit ? 'sic-row-value is-credit' : 'sic-row-value'
                    }
                  >
                    {item.value}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="sic-ledger">
            <p className="sic-set-micro">Ledger</p>
            <ul className="sic-readouts">
              <li className="sic-row">
                <span className="sic-row-label">Records on file</span>
                {loading ? (
                  <span className="sic-state is-muted">Reading…</span>
                ) : error ? (
                  <span className="sic-state is-error" role="status">
                    Ledger unavailable
                  </span>
                ) : (
                  <span className="sic-state">{accountCount}</span>
                )}
              </li>
              <li className="sic-row">
                <span className="sic-row-label">Latest account</span>
                {loading ? (
                  <span className="sic-state is-muted">Reading…</span>
                ) : error ? (
                  <span className="sic-state is-error" role="status">
                    Ledger unavailable
                  </span>
                ) : accountCount > 0 ? (
                  <span className="sic-state">
                    {formatAccountState(
                      accounts[accountCount - 1].status,
                      accounts[accountCount - 1].id
                    )}
                  </span>
                ) : (
                  <span className="sic-state is-muted">No accounts yet</span>
                )}
              </li>
            </ul>
          </div>

          <div className="sic-action">
            <p className="sic-note">Already hold an account?</p>
            <a className="sic-signin" href="/login">
              <span className="sic-signin-label">Sign in</span>
              <span className="sic-signin-route">/login</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SignUpIdentityContext;